module.exports = __webpack_public_path__ + "static/media/Foxy-Jumpscare.7c425050.gif";